import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import axios from 'axios';
import FlatList from 'flatlist-react';
import { baseUrl } from '../urlApi';
import Modal from 'react-modal';
import notifications from '../assets/notifications.svg'
import close from '../assets/close.svg'
import { LoadingApi } from '../components/LoadingApi';
import { ModalMailConfirm } from '../components/ModalMailConfirm';
import { useNavigate } from 'react-router-dom';


export const Homescreen = () => {
 
  const strcon = useSelector(state => state.login.token)
  const data = useSelector(state => state.login.data)

  // console.log(data,'data')

  const [avisos, setAvisos] = useState([])
  const [loading, setLoading] = useState(true)

  const [modalMail, setmodalMail] = useState(false)


  const navigate = useNavigate()

  // console.log('INFO',data)

  const closeModalMail = () => {

    setmodalMail(false)

  }

  const openModalMail = () =>{

    if (data.emailok === 'N'   ){
      setmodalMail(true)
    }


  }

  useEffect(() => {

    if(localStorage.getItem('emailok') === 'S'  ){
      return
    }

  
    localStorage.setItem('emailok',data.emailok)


   


    openModalMail()

  }, [])
  
     

    // console.log('fromdb',data.emailok)




  const consultarDatos = async () => {
   
      try {

          const response = await axios.post(`${baseUrl}comunicacion.asp`,
           {
              strcon
           });

          //  console.log(response.data)

           if(response.data.resultado === '0'){
               setAvisos([])

               setLoading(false)
           } else {
           setAvisos(response.data.avisos)
           setLoading(false)


           }

          //  console.log('largoavisos',avisos.lenght)


              
          } catch (error) {
            setLoading(false)
            
          alert("Error de conexion","Intentalo otra vez", );
              
          }


  }
  
    useEffect(() => {
      consultarDatos()
    }, [])



    const [modal, setModal] = useState(false)

    // objeto con la informacion adentro de acad aviso
    const [objAviso, setObjAviso] = useState(Object)

    const openModal = (obj) => {
      setModal(true)
      setObjAviso(obj)
    }

    const closeModal = () => {
      setModal(false)
    }

    //  funcion para hacer el salto de linea

    function replaceWithBr() {
      if(objAviso.texto){
        return objAviso.texto.replace(/\|/g, "<br />")
      }
     
    }


  return (
    <div className='animate__animated animate__fadeIn'>

      
            <div className='titulo' >
            <p >Portal de Autoconsulta de WebSal</p>
            </div> 

            <Modal
            isOpen={modalMail}
            contentClassName="content"
            onRequestClose={closeModalMail}
            contentLabel="Example Modal"
            ariaHideApp={false}
            >

              <ModalMailConfirm closeModalMail={closeModalMail} email={data.email} />
                
            </Modal>
            

            <div onClick={() => navigate('/firmaDigital') } className='ingreseFirmaDigital' >
              <p> Ingrese aquí para Firmar Documentos </p>
            </div>


         <div className='AvisotFlatlist' >

                    <div className='headerTablaAvisos' >
                            
                                <div className='contenedorTituloAvisos' >
                                <p>Avisos Generales</p>
                                  <img  className='avisosIcon' src={notifications} alt='ver' />

                                </div>
                                  
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 105 1440 215">
                                       <path fill="#7E85E1" fillOpacity="1" d="M0,256L120,256C240,256,480,256,720,234.7C960,213,1200,171,1320,149.3L1440,128L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"></path>
                                  </svg>



                    </div>
                    
                    <div className='contenidoTablaAvisos' >

                    <FlatList list={avisos} renderItem={(item,index) => 
                                    <>
                                              
                                        
                                                  <div key={index} className='divAvisos' >
                                                        <p>{item.desde}</p>
                                                        <p>{item.titulo}</p>
                                                        <p onClick={ () => openModal(item) }  >Ver</p>
                                                       
                                                        


                                                   </div>
                                      
                                      
                        
                                      </>

                                  
                                  
                                        
                                        }
                                        
                                        renderWhenEmpty={() =>
                                          <div className='renderEmpty' >

                                              {
                                                
                                                loading ? <LoadingApi/> : !loading  && avisos.length === 0? <p className='empty'>No tienes avisos</p> : null
                                              }
                                          

                                          </div>
                                        }
                                        hasMoreItems
                                        renderOnScroll
                                        />

                    </div>

         


         </div>

              <Modal
                contentClassName="content"
                isOpen={modal}
                ariaHideApp={false}
                onRequestClose={closeModal}
                contentLabel="Example Modal">

                  <button className='closeModal' onClick={closeModal} >

                  <img  className='closeIcon' src={close} alt='ver' />

                  </button>
              
            
                  <div className='modal' >

                        <p>{objAviso.titulo} </p>
                        <p>{objAviso.desde} </p>
                        <p className='justify' dangerouslySetInnerHTML={{__html: replaceWithBr()}} />


                  </div>
            
              </Modal>
        

              {/* <AppAdvisor/> */}
              {/* acava */}

    
    
    
    </div>
    
    
    
  )
}


